import React from "react";
import useDecimalFormat from "../../../../../../hooks/useDecimalFormat";

import TableItem from "../TableItem";
import * as Styles from "./styles";

interface DataProps {
  espontaneo: number;
  retorno: number;
  indicacao: number;
  ligacao: number;
  indicadoresEmpresas: any;
  total: number;
}
interface Props {
  data: DataProps;
}

const IndicatorCard: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.Column>
          <Styles.LightText>Espontânea</Styles.LightText>
          <Styles.StrongText>
            {/* @ts-ignore */}
            {props?.data?.espontaneo
              ? useDecimalFormat(props?.data?.espontaneo)
              : "--"}
          </Styles.StrongText>
        </Styles.Column>
        <Styles.Column>
          <Styles.LightText>Retorno</Styles.LightText>
          <Styles.StrongText>
            {/* @ts-ignore */}
            {props?.data?.retorno
              ? useDecimalFormat(props?.data?.retorno)
              : "--"}
          </Styles.StrongText>
        </Styles.Column>
        <Styles.Column>
          <Styles.LightText>Indicação</Styles.LightText>
          <Styles.StrongText>
            {/* @ts-ignore */}
            {props?.data?.indicacao
              ? useDecimalFormat(props?.data?.indicacao)
              : "--"}
          </Styles.StrongText>
        </Styles.Column>
        <Styles.Column>
          <Styles.LightText>Ligação</Styles.LightText>
          <Styles.StrongText>
            {/* @ts-ignore */}
            {props?.data?.ligacao
              ? useDecimalFormat(props?.data?.ligacao)
              : "--"}
          </Styles.StrongText>
        </Styles.Column>
      </Styles.Header>
      <Styles.Body>
        {props?.data?.indicadoresEmpresas.length > 0 ? (
          <Styles.TableHeader>
            <Styles.Cell style={{ minWidth: 110 }}>
              <Styles.HeaderText>Empresa</Styles.HeaderText>
            </Styles.Cell>
            <Styles.Cell>
              <Styles.HeaderText style={{ minWidth: 60 }}>
                Espontânea
              </Styles.HeaderText>
            </Styles.Cell>
            <Styles.Cell style={{ minWidth: 40 }}>
              <Styles.HeaderText>Retorno</Styles.HeaderText>
            </Styles.Cell>
            <Styles.Cell>
              <Styles.HeaderText>Indicação</Styles.HeaderText>
            </Styles.Cell>
            <Styles.Cell>
              <Styles.HeaderText>Ligação</Styles.HeaderText>
            </Styles.Cell>
            <Styles.Cell>
              <Styles.HeaderText>Total</Styles.HeaderText>
            </Styles.Cell>
          </Styles.TableHeader>
        ) : null}

        {props?.data?.indicadoresEmpresas.length > 0 ? (
          props?.data?.indicadoresEmpresas.map((item: any) => (
            <TableItem data={item} />
          ))
        ) : (
          <Styles.MessageContainer>
            <Styles.LightText>Nenhum registro encontrado</Styles.LightText>
          </Styles.MessageContainer>
        )}
      </Styles.Body>
      <Styles.Footer>
        <p>Total de atendimentos: </p>
        {/* @ts-ignore */}
        <span>
          {props?.data?.total ? useDecimalFormat(props?.data?.total) : "--"}
        </span>
      </Styles.Footer>
    </Styles.Container>
  );
};

export default IndicatorCard;
